var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-5",staticStyle:{"height":"calc(100vh - 3rem)"}},[_c('editor',{staticStyle:{"height":"calc(100% - 1rem)","width":"100%"},attrs:{"tools":[],"immutables":true,"value":_vm.htmlText,"rows":"10","cols":"30"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }